import { twMerge } from "tailwind-merge";
import { Icon } from "@/components/Icon";
import { sizeStyles } from "../constants";
import type { HierarchyNode } from "../types";

interface BackButtonProps<T extends HierarchyNode> {
  navigationStack: T[];
  onNavigateBack: () => void;
  size: "xs" | "sm" | "md";
}

export function BackButton<T extends HierarchyNode>({ navigationStack, onNavigateBack, size }: BackButtonProps<T>) {
  const backText =
    navigationStack.length === 1 ? "Back to main" : `Back to ${navigationStack[navigationStack.length - 2]?.name}`;

  return (
    <div className="sticky top-0 z-10 bg-background-surface border-b border-border-default flex-shrink-0">
      <button
        type="button"
        onClick={onNavigateBack}
        className={twMerge("w-full flex items-center gap-2 transition-colors text-left group", sizeStyles[size].node)}
      >
        <Icon
          name="CaretLeft"
          size={sizeStyles[size].icon}
          className="text-text-secondary group-hover:text-text-primary transition-colors"
        />
        <span className="font-medium text-text-primary group-hover:text-text-link-hover transition-colors">
          {backText}
        </span>
      </button>
    </div>
  );
}
